// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Ethers$SensumPwa from "../../blockchain/eth/ethers/Ethers.bs.js";
import * as State_Avatar$SensumPwa from "../../state/avatar/State_Avatar.bs.js";
import * as Core_Ui_Navbar$SensumPwa from "../../core/ui/navbar/Core_Ui_Navbar.bs.js";
import * as State_Sensations$SensumPwa from "../../state/sensations/State_Sensations.bs.js";

function Pages_Sensations$SensationsBody(Props) {
  var config = Props.config;
  var match = State_Sensations$SensumPwa.useSensations(config);
  var loadMore = match[2];
  var loading = match[1];
  var sensations = match[0];
  return React.createElement("div", {
              className: "flex flex-col flex-wrap"
            }, Belt_Array.mapWithIndex(sensations, (function (index, sensation) {
                    var match = State_Avatar$SensumPwa.getAvatarFromIndex(sensation.avatar);
                    var direction = index % 2 === 0 ? "flex-row" : "flex-row-reverse";
                    return React.createElement("div", {
                                key: String(index),
                                className: "flex " + direction + " flex-nowrap bg-black"
                              }, React.createElement("div", {
                                    className: "my-5 mx-1 w-28 h-28 bg-purple-900 flex items-center justify-center border-2 border-solid border-purple-50"
                                  }, React.createElement("label", {
                                        className: "pb-1 text-purple-50 " + match[1] + ""
                                      }, match[0])), React.createElement("div", {
                                    className: "my-5 mx-1 h-28 flex-1 items-center justify-center overflow-auto border-2 border-dotted border-purple-50"
                                  }, React.createElement("p", {
                                        className: "text-lg text-purple-50 font-medium px-2"
                                      }, sensation.message)));
                  })), loading ? React.createElement("div", {
                    className: "flex justify-center my-5"
                  }, React.createElement("label", {
                        className: "text-md p-2 text-purple-50"
                      }, "...LOADING...")) : null, !loading && sensations.length === 0 ? React.createElement("div", {
                    className: "flex justify-center my-5"
                  }, React.createElement("label", {
                        className: "text-md p-2 text-purple-50"
                      }, "[NUMB]")) : null, React.createElement("div", {
                  className: "flex justify-center my-5"
                }, React.createElement("button", {
                      className: "text-md p-2 text-purple-50 border-2 border-solid border-purple-50  disabled:opacity-50 hover:bg-purple-900",
                      disabled: loading || Ethers$SensumPwa.equalBigInt(match[3], Ethers$SensumPwa.toBigInt(-1)),
                      onClick: (function (param) {
                          Curry._1(loadMore, undefined);
                        })
                    }, "READ MORE")));
}

var SensationsBody = {
  make: Pages_Sensations$SensationsBody
};

function Pages_Sensations(Props) {
  var config = Props.config;
  return React.createElement("div", {
              className: "bg-black flex flex-col h-screen overflow-hidden"
            }, React.createElement(Core_Ui_Navbar$SensumPwa.make, {}), React.createElement("main", {
                  className: "overflow-y-scroll"
                }, React.createElement(Pages_Sensations$SensationsBody, {
                      config: config
                    })));
}

var make = Pages_Sensations;

export {
  SensationsBody ,
  make ,
}
/* react Not a pure module */
